module.exports = __webpack_public_path__ + "static/media/send_msg.5bd66378.mp3";